import { render, staticRenderFns } from "./scroll.vue?vue&type=template&id=3dc74e46"
import script from "./scroll.vue?vue&type=script&lang=js"
export * from "./scroll.vue?vue&type=script&lang=js"
import style0 from "./scroll.vue?vue&type=style&index=0&id=3dc74e46&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports